import { render, staticRenderFns } from "./record.vue?vue&type=template&id=1b7669d9&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"
import style0 from "./record.vue?vue&type=style&index=0&id=1b7669d9&prod&lang=less&scoped=true"
import style1 from "./record.vue?vue&type=style&index=1&id=1b7669d9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7669d9",
  null
  
)

export default component.exports